import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'loader-modal',
    templateUrl: '././loader.component.html',
    styleUrls: ['././loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderModalComponent implements OnInit, OnDestroy {
    @Input() message: string;

    constructor(
        private dialogRef: MatDialogRef<LoaderModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private spinner: NgxSpinnerService) {
        this.message = data.message;
    }

    ngOnInit() {
        this.spinner.show();
    }

    ngOnDestroy() {
        this.spinner.hide();
    }

}